// frontend/src/components/UI/CurrencyDisplay.jsx
import React from "react";
import { useCurrency } from "../../context/CurrencyContext";

const CurrencyDisplay = ({
  amountUSD,
  currency: overrideCurrency,
  compact = false,
  showOriginal = false,
  className = "",
}) => {
  const {
    currency: currentCurrency,
    formatAmount,
    getAllPrices,
    getSymbol,
  } = useCurrency();

  if (!amountUSD && amountUSD !== 0) {
    return <span className={className}>-</span>;
  }

  const targetCurrency = overrideCurrency || currentCurrency;

  const formattedPrice = formatAmount(amountUSD, {
    currency: targetCurrency,
    showSymbol: true,
  });

  if (compact) {
    return (
      <span className={`currency-display compact ${className}`}>
        {formattedPrice}
      </span>
    );
  }

  if (showOriginal) {
    const allPrices = getAllPrices(amountUSD);
    const symbolSLL = getSymbol("SLL");
    const symbolUSD = getSymbol("USD");

    return (
      <span className={`currency-display with-all ${className}`}>
        <span className="primary-price">
          {symbolSLL}
          {Math.round(allPrices.sll).toLocaleString()}
        </span>
        <span className="all-currencies">
          <span className="currency-sep">•</span>
          <span className="currency-item">
            {symbolUSD}
            {allPrices.usd.toFixed(2)}
          </span>
        </span>
      </span>
    );
  }

  return (
    <span className={`currency-display ${className}`}>{formattedPrice}</span>
  );
};

export default CurrencyDisplay;
